import { useCallback } from 'react';
import { useService } from '../api';
import { CustomerService } from './service';

export const useCustomerLogin = () => {
  const service = useService(CustomerService);

  const requestCustomerLogin = useCallback(
    async email => await service.requestCustomerLogin(email),
    [service],
  );

  return { requestCustomerLogin };
};
